// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1ElhI","info":"PatientInfo_info__3AhXB"};